import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MetaUiReadDto, PagedResponse } from '../models/meta-ui.model';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class MetaUiService {
      private apiUrl = `${environment.apiUrl}/api/MetaUi`; // Replace with your actual API URL

      constructor(private http: HttpClient) { }

      getAll(pageIndex: number, pageSize: number, searchTerm: string): Observable<PagedResponse<MetaUiReadDto>> {
            let params = new HttpParams()
                  .set('pageIndex', pageIndex.toString())
                  .set('pageSize', pageSize.toString())
                  .set('searchTerm', searchTerm);

            return this.http.get<PagedResponse<MetaUiReadDto>>(this.apiUrl, { params });
      }
      // POST: Create a new configuration
      create(dto: any): Observable<any> {
            return this.http.post(this.apiUrl, dto);
      }

      // PUT: Update an existing configuration
      update(id: string, dto: any): Observable<any> {
            return this.http.put(`${this.apiUrl}/${id}`, dto);
      }

      // DELETE: Remove a configuration
      delete(id: string): Observable<any> {
            return this.http.delete(`${this.apiUrl}/${id}`);
      }
}